(() => {
  const FORM_SELECTOR = 'form.js-email-signup-form';

  if (window.almaNewsletterSignupReady) return;
  window.almaNewsletterSignupReady = true;

  const cleanupShopifySuccessUrl = () => {
    const url = new URL(window.location.href);
    let shouldReplace = false;

    if (url.searchParams.has('customer_posted')) {
      url.searchParams.delete('customer_posted');
      shouldReplace = true;
    }

    if (url.hash === '#contact_form') {
      url.hash = '';
      shouldReplace = true;
    }

    if (shouldReplace) {
      window.history.replaceState(window.history.state, '', url.toString());
    }
  };

  const setMessage = (form, message, state) => {
    const messageEl = form.querySelector('.email-signup__message--client');
    if (!messageEl) return;

    messageEl.textContent = message;
    messageEl.dataset.state = state;
    messageEl.hidden = !message;
  };

  const setLoading = (form, isLoading, { disableButton = true } = {}) => {
    const button = form.querySelector('.email-signup__button');
    if (!button) return;

    button.classList.toggle('is-loading', isLoading);
    if (disableButton) {
      button.toggleAttribute('disabled', isLoading);
    }
    form.setAttribute('aria-busy', isLoading ? 'true' : 'false');
  };

  const handleSubmit = (event) => {
    const form = event.target instanceof Element ? event.target.closest(FORM_SELECTOR) : null;
    if (!(form instanceof HTMLFormElement)) return;

    const block = form.closest('[data-newsletter-block]');
    const input = form.querySelector('input[name="contact[email]"]');

    if (!(input instanceof HTMLInputElement) || !(block instanceof HTMLElement)) return;

    setMessage(form, '', 'error');

    const email = input.value.trim();
    input.value = email;

    if (!email) {
      event.preventDefault();
      event.stopImmediatePropagation();
      input.setAttribute('aria-invalid', 'true');
      setMessage(form, block.dataset.emptyMessage || '', 'error');
      input.focus();
      return;
    }

    if (!input.validity.valid) {
      event.preventDefault();
      event.stopImmediatePropagation();
      input.setAttribute('aria-invalid', 'true');
      setMessage(form, block.dataset.invalidMessage || '', 'error');
      input.focus();
      return;
    }

    input.removeAttribute('aria-invalid');
    setLoading(form, true, { disableButton: false });
  };

  const handleInvalid = (event) => {
    const input = event.target;
    const form = input instanceof HTMLInputElement ? input.closest(FORM_SELECTOR) : null;
    const block = form?.closest('[data-newsletter-block]');

    if (!(input instanceof HTMLInputElement) || !(form instanceof HTMLFormElement) || !(block instanceof HTMLElement)) return;

    event.preventDefault();
    input.setAttribute('aria-invalid', 'true');
    setMessage(form, input.value.trim() ? block.dataset.invalidMessage || '' : block.dataset.emptyMessage || '', 'error');
  };

  const initNewsletterForms = () => {
    document.querySelectorAll(`${FORM_SELECTOR}:not([data-newsletter-ready])`).forEach((form) => {
      form.dataset.newsletterReady = 'true';
      form.noValidate = true;
    });
  };

  document.addEventListener('submit', handleSubmit, true);
  document.addEventListener('invalid', handleInvalid, true);
  cleanupShopifySuccessUrl();
  initNewsletterForms();
  document.addEventListener('DOMContentLoaded', initNewsletterForms, { once: true });
  document.addEventListener('shopify:section:load', initNewsletterForms);
})();
